import { server_connection } from 'config';

export const UPDATE_COURSE_LOADED = '[ENROLLMENT APP] UPDATE COURSE LOADED';
export const GET_COMPANY_CALENDAR_COURSE_ENROLLMENT_DATA = '[ENROLLMENT APP] GET COMPANY CALENDAR COURSE ENROLLMENT DATA';
export const GET_COURSE_PREREQUISITES = '[ENROLLMENT APP] GET COURSE PRERQUISITES';
export const GET_COURSE_LAYOUT = '[ENROLLMENT APP] GET COURSE LAYOUT';
export const GET_COURSE_INSTRUCTORS = '[ENROLLMENT APP] GET COURSE INSTRUCTORS';
export const RESET_COURSE = '[ENROLLMENT APP] RESET COURSE';
export const GET_STUDENT_REQUIRMENTS_MET = '[ENROLLMENT APP] GET STUDENT REQUIRMENTS MET';

export function updateCourseLoaded(setting) {
    return {
        type: UPDATE_COURSE_LOADED,
        payload: setting
    }
}

export function getCompanyCalendarCourseEnrollmentData(company_calendar_course_id, student_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/course_detail',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ company_calendar_course_id, student_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COMPANY_CALENDAR_COURSE_ENROLLMENT_DATA,
                    payload: responseData
                });
            });
    }
}

export function getStudentRequirementsMet(company_calendar_course_id, student_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/student_requirements',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ company_calendar_course_id, student_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_STUDENT_REQUIRMENTS_MET,
                    payload: responseData
                });
            });
    }
}

export function getCoursePrerequisites(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/prerequisites/' + company_calendar_course_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_COURSE_PREREQUISITES,
                    payload: data,
                });
            });
    }
}

export function getCourseLayout(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/course_layout/' + company_calendar_course_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_COURSE_LAYOUT,
                    payload: data,
                });
            });
    }
}

export function getCourseInstructors(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/course_instructors/' + company_calendar_course_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_COURSE_INSTRUCTORS,
                    payload: data,
                });
            });
    }
}

export function resetCourse() {
    return {
        type: RESET_COURSE,
        payload: true
    }
}

export function getCourseData(company_calendar_course_id, student_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getCompanyCalendarCourseEnrollmentData(company_calendar_course_id, student_id)),
            dispatch(getCoursePrerequisites(company_calendar_course_id)),
            dispatch(getCourseLayout(company_calendar_course_id)),
            dispatch(getCourseInstructors(company_calendar_course_id)),
            dispatch(getStudentRequirementsMet(company_calendar_course_id, student_id))
        ]).then(
            () => dispatch(updateCourseLoaded(true))
        )
    }
}




// WEBPACK FOOTER //
// src/main/content/enrollment/store/actions/courseEnrollment.actions.js